import React , { useEffect , useState } from "react";
import { useSelector , useDispatch} from 'react-redux';

import { setFileattentes } from "../../state/redux";

import { searchandinitialiseclient } from "../../utils/actions_lead";


import eclair from "../../images/eclair.svg";

import './Periodes.scss'
let periodesnames = ['Matinée','Après-midi','Soirée'];
function Periodes(){


  const {leads}= useSelector(state=>state.leads);
  const [num_periode, setNum_periode] = useState(0) ;

  const leadsnrp = leads.filter(x=>['contact_nrp','devisenvoye_nrp']?.includes(x.statut_client)) ;


  const dispatch = useDispatch();



  const partagenrp = ()=>{

      let list1=[] ; let list2=[] ; let list3=[]  ; 
     for(let i=0; i<leadsnrp.length; i++ ){
           let lead = leadsnrp[i] ; 
           let heure= lead.date_rdvrelance? (new Date(lead.date_rdvrelance)).getUTCHours() : 11 ;
           heure<= 12 ? list1.push(lead['id']):heure<= 16 ? list2.push(lead['id']): list3.push(lead['id']);
     }
     return [list1, list2, list3]
    }

    const newpartage = partagenrp() ;



     const clickperiode  = (e)=>{  
      setNum_periode(parseInt(e.target.id)) ;
      const liste = newpartage[parseInt(e.target.id)] ;
      dispatch(setFileattentes([...liste]))
     }

      useEffect(()=>{
        let heureactu = (new Date()).getHours();
        const num_periode0 =   heureactu<12?0:heureactu<16?1:2 ; 
        setNum_periode(num_periode0) ;
        const liste = newpartage[num_periode0] ;
        dispatch(setFileattentes([...liste]))
        partagenrp() ;
      },[]) ;

    const divchoiced = (y)=>(<div  id={y}  key={y}  className="periodes_now"  onClick={clickperiode} >
                                {periodesnames[num_periode]}
                                <img src={eclair}  width="14" height="14"   alt="eclair" />
                                <span >{(newpartage[num_periode]||[]).length} </span> 
                          </div>) ;

    const divnochoiced = (y)=>(<div  id={y}  key={y} className="periodes_autre"  onClick={clickperiode}  >
                                    <div className="periodes_autre_texte"> {periodesnames[y]} </div>
                                    <span >{(newpartage[y]||[]).length}</span>  
                                </div>)
   
   const demarrersequence = ()=>{const liste = newpartage?.[num_periode] ;
                                  if(liste.length===0) return
                                  searchandinitialiseclient(liste?.[0],true)
   }

    return(<div  className="periodes"> 
             <div className="periodes_groupe" >
                {[0,1,2].map(y=>y===num_periode?divchoiced(y):divnochoiced(y))}
            </div>
            <div className='demarrersequence'onClick={() =>{demarrersequence()}}  >Démarrer la séquence</div>
         </div>)
}


export default Periodes